export class Capture {
  constructor(public filename = "",
              public src = "",
              public fileSize = "",
              public isImage = false) {
  }

}
